export default __webpack_public_path__ + "static/media/diagram-kr.b617bfe4.png";